export default __webpack_public_path__ + "static/media/item4.1b4e6b5f.png";